import { render, staticRenderFns } from "./Shangjiatuijie.vue?vue&type=template&id=84436394&"
import script from "./Shangjiatuijie.vue?vue&type=script&lang=js&"
export * from "./Shangjiatuijie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports